import {version} from '../../package.json';

export function setVersion() {
  if (!(window as any)['CoveoCusto']) {
    (window as any)['CoveoCusto'] = {version};
  }
}